import KunLoading108 from './src/index'

KunLoading108.install = function (Vue) {
	Vue.component(KunLoading108.name, KunLoading108);
}

export default KunLoading108;
